import React, { useEffect, useState } from "react";
import { formatTime24to12 } from "../../common/commonFunctions";
import { callApi } from "../../utils/api";
declare var $: any;

export default function ShiftExtensionAlert({ shiftEndTime, close, onRequestExtend, requestSubmitted }) {
  // const alertSlots = [60, 30, 15, 5, 2]; // minutes before shift end
  const parsedCurrentShiftEnd = shiftEndTime ? JSON.parse(shiftEndTime) : '';
  const [alertSlots, setAlertSlots] = useState<number[]>([]);
  const [triggeredSlots, setTriggeredSlots] = useState<number[]>([]);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [message, setMessage] = useState<string>("");
  const [enableAutoRefresh, setEnableAutoRefresh] = useState<boolean>(true);

  // ✅ On mount, check if request already submitted
  useEffect(() => {
    const stored = localStorage.getItem("shiftExtensionRequestSubmitted");
    if (stored === "true") {
      setAlreadySubmitted(true);
    }
  }, []);

  useEffect(() => {
    if (requestSubmitted) {
      setAlreadySubmitted(true);
    }
  }, [requestSubmitted]);

  // Reset triggered slots when shiftEndTime changes
  useEffect(() => {
    setTriggeredSlots([]);
  }, [shiftEndTime]);

  // Hide modal if parent forces close
  useEffect(() => {
    if (close) {
      $("#extension-modal").modal("hide");
    }
  }, [close]);

  useEffect(() => {
    if (!shiftEndTime || typeof shiftEndTime !== "string" || alreadySubmitted) return;

    const checkAlert = () => {
      const now = new Date();
      const cleaned = shiftEndTime.replace(/[^\d:]/g, "");
      const parts = cleaned.split(":");
      if (parts.length < 2) return;

      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      if (isNaN(hours) || isNaN(minutes)) return;

      const shiftEndDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes,
        0
      );

      const diffMinutes = (shiftEndDate.getTime() - now.getTime()) / 60000;

      if (diffMinutes <= 0) return; // shift already over

      // Loop through alert slots
      alertSlots.forEach((slot) => {
        if (
          diffMinutes <= slot &&
          diffMinutes > slot - 1 && // within this 1-min window
          !triggeredSlots.includes(slot)
        ) {
          $("#extension-modal").modal("show");
          setTriggeredSlots((prev) => [...prev, slot]);
        }
      });
    };

    const interval = setInterval(checkAlert, 1000);
    return () => clearInterval(interval);
  }, [shiftEndTime, triggeredSlots, alreadySubmitted, alertSlots]);

  useEffect(() => {
    const fetchSlots = () => {
      const authKey = localStorage.getItem("authkey");
      if (authKey) {
        callApi("GET", "get_shift_alert_slots.php")
          .then(({ data }) => {
            if (data.result) {
              setAlertSlots(data?.slots || []);
              setMessage(data?.message || "");
              setEnableAutoRefresh(false); // after first fetch stop auto refresh
              localStorage.setItem("alertSlots", JSON.stringify(data?.slots));
            }
          })
          .catch((err) => console.error("Error fetching slots:", err));
      }
    };

    let interval: NodeJS.Timeout | null = null;

    if (enableAutoRefresh) {
      interval = setInterval(fetchSlots, 10 * 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [enableAutoRefresh]); // 👈 dependency added


  const handleRequestExtend = () => {
    // mark submitted → block future alerts
    // localStorage.setItem("shiftExtensionRequestSubmitted", "true");
    setAlreadySubmitted(true);
    onRequestExtend();
  };

  return (
    <>
      <div
        className="modal hide fade in"
        id="extension-modal"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className="modal-dialog ">
          <div
            className="modal-content"
            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
          >
            <div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}>
              <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                Your shift ends at <b>{formatTime24to12(parsedCurrentShiftEnd)}</b>. {message || "Would you like to request an extension?"}
              </h5>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary m-1"
                onClick={handleRequestExtend}
              >
                Request Extension
              </button>
              <button
                type="button"
                className="btn btn-danger m-1"
                onClick={() => {
                  $("#extension-modal").modal("hide");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
